import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// @ts-nocheck
/* eslint-disable import/no-extraneous-dependencies */
import classnames from 'classnames';
import * as React from 'react';
import { filterDataProps } from '../../utils/FilterDataProps';
import { st, classes } from './CoreInput.st.css';
export class CoreInput extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      focus: false
    });
    _defineProperty(this, "input", void 0);
    _defineProperty(this, "_extractRef", ref => {
      const {
        inputRef
      } = this.props;
      this.input = ref;
      if (inputRef) {
        inputRef(ref);
      }
    });
    _defineProperty(this, "handleFocus", event => {
      this.setState({
        focus: true
      });
      this.props.onFocus(event);
    });
    _defineProperty(this, "handleBlur", event => {
      this.setState({
        focus: false
      });
      this.props.onBlur(event);
    });
  }
  render() {
    const {
      focus
    } = this.state;
    const {
      error,
      disabled,
      prefix,
      suffix,
      style: inlineStyle,
      id
    } = this.props;
    const {
      error: errorProp,
      style: styleProp,
      prefix: prefixProps,
      suffix: suffixProp,
      inputClassName,
      className,
      inputRef,
      ...allOtherProps
    } = this.props;
    return /*#__PURE__*/React.createElement("div", _extends({
      className: st(classes.root, {
        disabled,
        error: !!error && !disabled,
        focus
      }, className),
      style: inlineStyle
    }, filterDataProps(this.props)), prefix, /*#__PURE__*/React.createElement("input", _extends({
      id: id
    }, allOtherProps, {
      ref: this._extractRef,
      className: classnames(classes.nativeInput, inputClassName),
      onBlur: this.handleBlur,
      onFocus: this.handleFocus
    })), suffix);
  }
  focus() {
    this.input.focus();
  }
  blur() {
    this.input.blur();
  }
  select() {
    this.input.select();
  }
  getSelectionStart() {
    return this.input.selectionStart;
  }
  getSelectionEnd() {
    return this.input.selectionEnd;
  }
  setSelectionRange(start, end) {
    this.input.setSelectionRange(start, end);
  }
}
_defineProperty(CoreInput, "displayName", 'CoreInput');
_defineProperty(CoreInput, "defaultProps", {
  type: 'text',
  onFocus: () => null,
  onBlur: () => null,
  onChange: () => null
});
//# sourceMappingURL=CoreInput.js.map